import { createRoute, redirect } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";
import { cacheBackendToken } from "@/lib/tokenCache";

// Token capture happens in beforeLoad -- runs BEFORE any React component
// mounts, so the token is in localStorage before AuthProvider's useState
// initializer calls getBackendToken().  This eliminates the race condition
// between TokenExpirationHandler (which clears tokens when !isAuthenticated)
// and the old useEffect that stored the token after mount.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "auth/callback",
  beforeLoad: () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      cacheBackendToken(token);
    }
    // Client-side redirect to /dashboard.  Because beforeLoad runs before
    // the root component tree mounts, AuthProvider will initialise with the
    // token already present in localStorage.
    throw redirect({ to: "/dashboard" });
  },
});
